const DEFAULT_CENTER = { lat: 38.9013347, lng: -77.022491 }
const DEFAULT_ZOOM = 8
const DEFAULT_MAP_ID = '44503b3f7e5bd432'

let googleMapsPromise

export function getDefaultMapOptions() {
    return {
        center: DEFAULT_CENTER,
        zoom: DEFAULT_ZOOM,
        mapId: DEFAULT_MAP_ID,
        mapTypeControl: false,
        streetViewControl: false,
    }
}

export function loadGoogleMaps(apiKey) {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Google Maps can only load in the browser.'))
    }

    if (window.google?.maps?.Map) {
        return Promise.resolve(window.google)
    }

    if (!googleMapsPromise) {
        const effectiveKey = apiKey
        if (!effectiveKey) {
            googleMapsPromise = Promise.reject(new Error('Missing Google Maps API key.'))
            return googleMapsPromise
        }

        googleMapsPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-google-maps-loader="true"]')
            if (existing) {
                existing.addEventListener('load', () => {
                    if (window.google?.maps) {
                        resolve(window.google)
                    } else {
                        reject(new Error('Google Maps failed to initialize.'))
                    }
                })
                existing.addEventListener('error', () => reject(new Error('Google Maps failed to load.')))
                return
            }

            const script = document.createElement('script')
            const params = new URLSearchParams({
                key: effectiveKey,
                v: 'weekly',
                libraries: 'marker',
            })
            script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`
            script.async = true
            script.defer = true
            script.dataset.googleMapsLoader = 'true'
            script.onload = () => {
                if (window.google?.maps) {
                    resolve(window.google)
                } else {
                    reject(new Error('Google Maps failed to initialize.'))
                }
            }
            script.onerror = () => reject(new Error('Google Maps failed to load.'))
            document.head.appendChild(script)
        })
    }

    return googleMapsPromise
}

export function extractMapPosition(map) {
    const center = map.getCenter()
    const zoom = map.getZoom()
    const bounds = map.getBounds()
    return {
        center: center
            ? { lat: Number(center.lat()), lng: Number(center.lng()) }
            : DEFAULT_CENTER,
        zoom: Number.isFinite(zoom) ? zoom : DEFAULT_ZOOM,
        bounds: bounds,
    }
}
